export const TRANSLATION_NAMESPACE = 'mediaHubImageSearch';
